import React from 'react';
import PropTypes from 'prop-types';
import css from './ProfileNotFound.css';
import { Link } from 'react-router-dom';

const ProfileNotFound = ({renderNotification}) => (
  <>
    {renderNotification && renderNotification()}
    <div className={css['container']}>
      <img src="../images/alert.svg" />
      <h1>Oops! Something went wrong...</h1>
      <Link to="/" className={css['button']}>
        Go to Success Network
      </Link>
    </div>
  </>
);

ProfileNotFound.propTypes = {
  renderNotification: PropTypes.func,
};

export default ProfileNotFound;
